import { Calculator } from './Calculator';
import { TestUtil } from './TestUtil';
import { UIUtil } from './UIUtil';

declare global {
  interface Window {
    Meter: any;
  }
}

export class Meter {
  static readonly FILL_RIGHT = 0;
  static readonly FILL_LEFT = 1;
  static readonly FILL_UP = 2;
  static readonly FILL_DOWN = 3;
  static readonly FILL_OUT_HORIZONTALLY = 4;
  static readonly FILL_OUT_VERTICALLY = 5;

  public fill: any;
  public max!: number;
  public animMs: number;
  public mode!: number;
  public textField: any;

  constructor(fill: any, max?: number, animMs?: number, mode?: number) {
    if (fill == null) TestUtil.warn("'fill' is null");
    this.fill = fill;
    this.setMax(max || 1.0);
    this.animMs = Calculator.isDefined(animMs) ? (animMs as number) : 500;
    this.setMode(mode || 0);
  }

  setMax(max: number): void {
    this.max = max;
  }

  setMode(mode: number): void {
    this.mode = mode;
    const bounds = this.fill.nominalBounds;

    switch (mode) {
      case Meter.FILL_RIGHT:
        UIUtil.setRegistrationPoint(this.fill, 0, bounds.height / 2);
        break;
      case Meter.FILL_DOWN:
        UIUtil.setRegistrationPoint(this.fill, bounds.width / 2, 0);
        break;
      case Meter.FILL_LEFT:
        UIUtil.setRegistrationPoint(this.fill, bounds.width, bounds.height / 2);
        break;
      case Meter.FILL_UP:
        UIUtil.setRegistrationPoint(this.fill, bounds.width / 2, bounds.height);
        break;
      case Meter.FILL_OUT_HORIZONTALLY:
      case Meter.FILL_OUT_VERTICALLY:
        UIUtil.setRegistrationPoint(
          this.fill,
          bounds.width / 2,
          bounds.height / 2,
        );
        break;
    }

    if (
      this.mode == Meter.FILL_RIGHT ||
      this.mode == Meter.FILL_LEFT ||
      this.mode == Meter.FILL_OUT_HORIZONTALLY
    ) {
      this.fill.scaleX = 0.0;
    } else {
      this.fill.scaleY = 0.0;
    }
  }

  bindTextField(textField: any): void {
    this.textField = textField;
  }

  update(value: number, animate?: boolean): number {
    if (!Calculator.isDefined(animate)) animate = true;

    value = Calculator.bound(value, 0, this.max);

    if (
      this.mode == Meter.FILL_RIGHT ||
      this.mode == Meter.FILL_LEFT ||
      this.mode == Meter.FILL_OUT_HORIZONTALLY
    ) {
      UIUtil.tween(
        this.fill,
        'scaleX',
        value / this.max,
        animate ? this.animMs : 0,
      );
    } else {
      UIUtil.tween(
        this.fill,
        'scaleY',
        value / this.max,
        animate ? this.animMs : 0,
      );
    }

    if (this.textField != null && this.textField.displayAsPercent) {
      this.textField.text = '' + Calculator.round(value * 100, 0) + '%';
    } else if (this.textField != null) {
      this.textField.text = '' + value;
    }

    return value;
  }
}
